module.exports = __webpack_public_path__ + "static/media/HSBC.4097fd5b.png";